// extracted by mini-css-extract-plugin
export default {"chatBallon":"style_chatBallon__wiGxX","arrowBox":"style_arrowBox__X5FpJ"};